var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4688 5.46875H13.8021M10.4688 8.38542H12.9688",
    stroke: "#333333",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 0.46875H4.63542C2.33423 0.46875 0.46875 2.33423 0.46875 4.63542V11.3021C0.46875 13.6033 2.33423 15.4688 4.63542 15.4688H12.9688C15.2699 15.4688 17.1354 13.6033 17.1354 11.3021V4.63542C17.1354 2.33423 15.2699 0.46875 12.9688 0.46875Z",
    stroke: "#333333",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96875 11.3047C3.97542 9.15385 7.72875 9.01302 8.80208 11.3047M7.55208 5.47135C7.55208 5.91338 7.37649 6.3373 7.06393 6.64987C6.75137 6.96243 6.32744 7.13802 5.88542 7.13802C5.44339 7.13802 5.01947 6.96243 4.70691 6.64987C4.39434 6.3373 4.21875 5.91338 4.21875 5.47135C4.21875 5.02933 4.39434 4.6054 4.70691 4.29284C5.01947 3.98028 5.44339 3.80469 5.88542 3.80469C6.32744 3.80469 6.75137 3.98028 7.06393 4.29284C7.37649 4.6054 7.55208 5.02933 7.55208 5.47135Z",
    stroke: "#333333",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.3f5cfa4752b949d9f72df62956ffc73c.svg";
export { ForwardRef as ReactComponent };